/**
 * How the page is being displayed: inside an installed home-screen app (`standalone`) or in a normal
 * browser tab (`browser`). `unknown` is the server, where there is no window to ask.
 *
 * Two signals on purpose. `matchMedia('(display-mode: standalone)')` is the standard and covers
 * Android and desktop installs; `navigator.standalone` is the legacy iOS Safari flag, which older
 * iOS versions set without matching the media query. Either one is enough.
 */
export type DisplayMode = 'browser' | 'standalone' | 'unknown';

interface NavigatorWithStandalone extends Navigator {
  standalone?: boolean;
}

export function detectDisplayMode(): DisplayMode {
  if (typeof window === 'undefined') {
    return 'unknown';
  }

  try {
    if (window.matchMedia?.('(display-mode: standalone)').matches) {
      return 'standalone';
    }

    if ((window.navigator as NavigatorWithStandalone).standalone === true) {
      return 'standalone';
    }
  } catch {
    return 'unknown';
  }

  return 'browser';
}
